import React from "react";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import sourceByIdStore from "../../flux/stores/source/ByIdStore";

import * as CONSTANTS from "../../utilities/Constants";
import SourceViewData, {
  defaultSourceData,
} from "../../models/source/SourceViewData";

import "./source.sass";
import { Translation } from "react-i18next";
import History from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  sourceData: SourceViewData;
}

export default class Landing extends React.Component<{}, ILandingState> {
  private _mount: boolean = false;
  private _moduleName = CONSTANTS.MODULE_SOURCE;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      sourceData: defaultSourceData,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    sourceByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ sourceData: state.sourceData });
      }
    });
  }
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.MENU_SOURCE), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader data={this.state.sourceData.name} authKey={CONSTANTS.AUTHKEY_SOURCE}/>
            <div className="summary-layout">
              <Summary>
                <div className="page-scroll">
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <span className="summary-label">
                        {" "}
                        {t(this.state.sourceData.codeLabel)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.sourceData.code}
                      </span>
                    </div>

                    <div className="col-md-3">
                      <span className="summary-label">
                        {" "}
                        {t(CONSTANTS.LABEL_STRIP_LENGTH)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.state.sourceData.stripLength}
                      </span>
                    </div>

                    <div className="col-md-6" style={{ display:'flex' }}>
                      <span className="summary-label">
                        {t(this.state.sourceData.descriptionLabel)}:
                      </span>
                      <div className="ellipsis-single-line" style={{lineHeight:'20px'}}>
                      <span className="summary-value ml-2">
                        {this.state.sourceData.description}
                      </span></div>
                    </div>
                  </div>
                </div>
              </Summary>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
